module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('aside', {
    staticClass: "sidebar",
    class: {
      show: _vm.asideShow
    }
  }, [_c('nav', [_c('div', {
    staticClass: "search-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    staticClass: "search",
    class: [_vm.inputing ? 'active' : ''],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchResult.length > 0 && _vm.inputing),
      expression: "searchResult.length > 0 && inputing"
    }],
    staticClass: "no-list-style"
  }, _vm._l((_vm.searchResult), function(result) {
    return _c('li', {
      staticClass: "result-item"
    }, [_c('router-link', {
      attrs: {
        "to": '/source/' + result.id
      }
    }, [_vm._v(_vm._s(result.id) + " . " + _vm._s(result.title))])], 1)
  }))]), _vm._v(" "), _c('ul', {
    staticClass: "nav-link-container"
  }, [_c('li', {
    staticClass: "nav-link-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/cover"
    }
  }, [_vm._v(_vm._s(_vm.language === 'en' ? "Guide" : "介绍"))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-link-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/source"
    }
  }, [_vm._v(_vm._s(_vm.language === 'en' ? "Source Code" : "源码"))])], 1), _vm._v(" "), (_vm.gitRepoUrl !== null) ? _c('li', {
    staticClass: "nav-link-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "target": "_blank",
      "href": _vm.gitRepoUrl
    }
  }, [_c('img', {
    staticClass: "github-logo",
    attrs: {
      "src": require("../../assets/github.jpeg")
    }
  }), _vm._v("git repos")])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "question-links-container"
  }, _vm._l((_vm.problems), function(value, key) {
    return _c('li', {
      staticClass: "question-link"
    }, [_c('router-link', {
      attrs: {
        "to": '/source/' + key,
        "exact": ""
      }
    }, [_vm._v(_vm._s(key) + "." + _vm._s(_vm.problems[key]['title']))])], 1)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        _vm.asideShow = false
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-360b3143!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SideBar.vue
// module id = 74
// module chunks = 2